// extracted by mini-css-extract-plugin
module.exports = {"regulatoryHeader":"_d12fa18"};